'use client';

// module imports
import { ReactNode } from 'react';
import { Provider } from 'react-redux';

// file imports
import { store } from '@/redux/store';

interface ReduxProviderProps {
  children: ReactNode;
}

export default function ReduxProvider({ children }: ReduxProviderProps) {
  return <Provider store={store}>{children}</Provider>;
}
